import {
  LogisticsApi,
  LogisticsApiGetPresignedURLLabelRequest
} from '@itsrever/rever-api'
import { apiClient } from '@/infrastructure/api'

const logisticsApi = new LogisticsApi(undefined, undefined, apiClient)

export async function getPresignedURLLabel(
  req: LogisticsApiGetPresignedURLLabelRequest
) {
  const data = await logisticsApi.getPresignedURLLabel(req)

  return data.data
}
